export default __webpack_public_path__ + "static/media/story_img_2.4e12b036.jpeg";